import { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电影分类", to: "/category" },
  { label: "影视资讯", to: "/news" },
  { label: "关于我们", to: "/about" },
];

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [keyword, setKeyword] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const submitSearch = (event: React.FormEvent) => {
    event.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
    setMenuOpen(false);
  };

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled
          ? "border-background-200 bg-background-50/95 backdrop-blur-md"
          : "border-transparent bg-background-50/80 backdrop-blur"
      }`}
    >
      <div className="mx-auto flex h-16 w-full items-center gap-4 px-4 md:px-6 lg:px-10">
        <Link to="/" className="flex shrink-0 items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-film-fill text-lg"></i>
          </span>
          <span className="font-heading text-lg font-extrabold tracking-tight text-foreground-50">
            午夜场的电影
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                `rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? "text-primary-400"
                    : "text-foreground-300 hover:text-foreground-50"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <form
          onSubmit={submitSearch}
          className="ml-auto hidden items-center gap-2 md:flex"
        >
          <div className="flex items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 py-1.5 focus-within:border-primary-500">
            <i className="ri-search-line text-sm text-foreground-500"></i>
            <input
              type="text"
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="搜索午夜电影或资讯"
              className="w-40 bg-transparent text-sm text-foreground-50 outline-none placeholder:text-foreground-600 lg:w-56"
            />
          </div>
          <button
            type="submit"
            className="whitespace-nowrap rounded-md bg-primary-500 px-3.5 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            搜索
          </button>
        </form>

        <button
          type="button"
          onClick={() => setMenuOpen((open) => !open)}
          aria-label="打开菜单"
          className="ml-auto flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-100 md:hidden"
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-4 md:hidden">
          <form onSubmit={submitSearch} className="mb-4 flex items-center gap-2">
            <div className="flex flex-1 items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 py-2 focus-within:border-primary-500">
              <i className="ri-search-line text-sm text-foreground-500"></i>
              <input
                type="text"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="搜索午夜电影或资讯"
                className="w-full bg-transparent text-sm text-foreground-50 outline-none placeholder:text-foreground-600"
              />
            </div>
            <button
              type="submit"
              className="whitespace-nowrap rounded-md bg-primary-500 px-3.5 py-2 text-sm font-semibold text-background-50"
            >
              搜索
            </button>
          </form>
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `flex items-center justify-between rounded-md px-3 py-3 text-sm font-medium transition-colors ${
                    isActive
                      ? "bg-background-100 text-primary-400"
                      : "text-foreground-200 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
                <i className="ri-arrow-right-s-line text-lg text-foreground-600"></i>
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}